import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProvider } from './context/AppContext';
import './index.css';
import App from './App';
import i18n from './language/index';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 0,
            refetchOnMount: 'always',
            refetchOnWindowFocus: true,
            refetchOnReconnect: true
        }
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient}>
        <AppProvider>
            <App />
        </AppProvider>
    </QueryClientProvider>
);
